import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useFormDisable } from '../../../../../../shared/form-new/form'
import { CopyValue } from '../../../../../../shared/sso-workspace/copy-value'
import { FromIssuerTag } from '../../../../../../shared/sso-workspace/from-issuer-tag'

// What happens when someone signs out (spec section 5). The choice is
// endIdpSessionOnSignout; the endpoint is signoutURL, which the identity
// section's lookup may fill from the issuer's end_session_endpoint.
export const SectionSignout = ({ fromIssuer, pulseKey, issuerEndpoint }) => {
  const { watch, setValue, register } = useFormContext()
  const formDisabled = useFormDisable()
  const endIdp = Boolean(watch('endIdpSessionOnSignout'))
  // Read-only only while it holds exactly what the issuer publishes, so an
  // admin who clears it (or an issuer that publishes none) can still type one.
  const current = watch('signoutURL')
  const published = Boolean(issuerEndpoint) && current === issuerEndpoint
  const note = published
    ? 'Published by the issuer.'
    : issuerEndpoint
      ? `Differs from what the issuer publishes (${issuerEndpoint}).`
      : 'The issuer publishes none. Enter it only if the identity provider has one.'
  const returnURL = `${process.env.REACT_APP_API_AUTH}/api/v1/auth-logout/return`
  const choose = value => setValue('endIdpSessionOnSignout', value, { shouldDirty: true })

  return (
    <div className="d-grid gap-3">
      <div className="d-grid gap-2" role="radiogroup" aria-label="when someone signs out">
        <label className={`sw-choice ${!endIdp ? 'sw-checked' : ''}`}>
          <input type="radio" className="form-check-input mt-1" name="sw-signout" checked={!endIdp} disabled={formDisabled} onChange={() => choose(false)} />
          <span><strong className="d-block">End their EducationXR session only</strong><span className="sw-hint">Recommended. Outlook, Teams and other apps stay signed in, like Slack and Zoom. When people must sign in again is set by their identity provider's policies.</span></span>
        </label>
        <label className={`sw-choice ${endIdp ? 'sw-checked' : ''}`}>
          <input type="radio" className="form-check-input mt-1" name="sw-signout" checked={endIdp} disabled={formDisabled} onChange={() => choose(true)} />
          <span><strong className="d-block">Also sign them out of the identity provider</strong><span className="sw-hint">For shared devices. Ends their sign-in there in that browser, so every other app on that account signs out too.</span></span>
        </label>
      </div>
      {endIdp &&
        <div className="sw-note small d-grid gap-2">
          <span>Register this as a redirect URI on the app registration so people are brought back afterwards:</span>
          <CopyValue id="sw-return" label="Sign-out return" value={returnURL} />
          <span>For Microsoft, add the optional ID-token claim <code>login_hint</code> too, so Microsoft doesn't ask which account to sign out.</span>
        </div>}
      <div className="sw-field" style={{ maxWidth: 640 }}>
        <label className="sw-label" htmlFor="signoutURL">Sign-out endpoint<FromIssuerTag show={fromIssuer || published} pulseKey={pulseKey} /></label>
        <input id="signoutURL" className="form-control sw-mono" readOnly={published} {...register('signoutURL')} disabled={formDisabled} />
        <div className="sw-hint">{note}</div>
      </div>
    </div>
  )
}
